import React from 'react';
import cn from 'classnames';
import { Title } from '@landing/ui';
import { Contacts } from 'components/UI';
import Logos from './components/Logos';

import * as styles from './ModalAside.module.scss';

export default function ModalAside({ className, theme }) {
  const customers = (
    <>
      <p className={styles.sectionTitle}>Kunden, die uns vertrauen</p>
      <Logos />
    </>
  );

  return (
    <div className={cn(styles.wrapper, className, theme && styles[theme])}>
      <section className={styles.section}>
        <Title className={styles.title} color="white">
          Haben Sie Fragen? Kontaktieren Sie Andersen für eine kostenlose Beratung. Vertrauen Sie
          Ihre IT-Initiative echten Software-Experten an.
        </Title>
      </section>
      <section className={styles.section}>
        <p className={styles.sectionTitle}>Kontaktieren Sie uns</p>
        <Contacts className={styles.contacts} theme="column" />
      </section>
      <section className={styles.section}>{customers}</section>
    </div>
  );
}
